// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { GridItem } from '../../../../../components/layout';
import Grid from '../../../../../components/layout/Grid';
import Field from '../../../../../components/card/Field';
import Selects from '../../../../../components/selects';
import { InputNumber } from '../../../../../components/inputs';
import Modal from '../../../../../components/ant/Modal';
const {
  PddGroupSelect
} = Selects;
export const GroupModal = props => {
  const [group, setGroup] = useState(null);
  useEffect(() => {
    setGroup(props.group);
  }, [props.group]);
  return <Modal centered destroyOnHidden footer={[!props.group?.id ? <Button key="back" onClick={() => props.onClose()}>
            Отмена
          </Button> : null, props.group?.id ? <Button key="back" type="danger" onClick={() => props.onDelete(props.group)}>
            Удалить тему
          </Button> : null, <Button disabled={!group?.pddGroupId} key="submit" type="primary" onClick={() => props.onSave(props.group, group)}>
          Сохранить
        </Button>]} title={'Прикрепление темы ПДД'} visible={props.visible} onCancel={props.onClose} width={500} height={500}>
      <Grid cols={1}>
        <GridItem>
          <Field>
            <PddGroupSelect value={group?.pddGroupId} onChange={(value, option) => {
            // $FlowFixMe флоу считает что передается функция
            setGroup({
              ...group,
              pddGroupId: value,
              pddGroup: option.props.group
            });
          }} />
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Кол-во вопросов в билете">
            <InputNumber value={group?.questionCount}
          // $FlowFixMe флоу считает что передается функция
          onChange={value => setGroup({
            ...group,
            questionCount: value
          })} />
          </Field>
        </GridItem>
      </Grid>
    </Modal>;
};
